import StimulusSortable from "@stimulus-components/sortable"

export default class extends StimulusSortable {
  // Touch drags start after a short hold so scrolling still works on
  // mobile; mouse drags stay instant.
  get defaultOptions() {
    return { delay: 150, delayOnTouchOnly: true, touchStartThreshold: 4 }
  }

  async onUpdate(event: { item: HTMLElement; newIndex: number }) {
    this.updatePositionLabels()
    await super.onUpdate(event)
  }

  private updatePositionLabels() {
    this.element
      .querySelectorAll("[data-role='position']")
      .forEach((el, index) => {
        el.textContent = String(index + 1)
      })
  }
}
